module.exports = __webpack_public_path__ + "img/11.412ccba3.png";